export default __webpack_public_path__ + "static/console-6140c4c03ed1ded79d1e5fb569d32f09.svg";